import { render } from "./ApplicationFormsList.vue?vue&type=template&id=557f4526&scoped=true"
import script from "./ApplicationFormsList.vue?vue&type=script&lang=js"
export * from "./ApplicationFormsList.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-557f4526"

export default script